import PropTypes from 'prop-types';

export const questionShape = {
  id: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
};

export const listShape = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape(questionShape)).isRequired,
};

export const styleShape = {
  card: PropTypes.shape({ color: PropTypes.string }),
};

export const styleDefault = {
  style: {
    card: {
      backgroundColor: 'rgb(230,230,230)',
    },
  },
};
